import { makeStyles } from "@material-ui/core";
export var useStyles = makeStyles(function (theme) { return ({
    root: {
        display: "flex",
        flex: "0 0 100%",
        backgroundColor: theme.palette.background.default,
        flexDirection: "row",
        height: "100%",
        width: "100%",
        overflow: "hidden",
    },
    body: {
        display: "flex",
        flex: "1",
        flexDirection: "column",
        width: "100%",
        overflow: "hidden",
        paddingLeft: 0,
        transition: "padding-left 300ms",
    },
}); });
